import { HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, LanguageSelectors, renderStringToReact, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalAchievementsList } from '../achievements';
import { SKELETON_CLASSNAME } from '../base/constants';
import SideBarSection from '../components/SideBarSection/SideBarSection';
import { CyclesSelectors } from '../cycles';
import Day0Banner from '../d0banner/Day0Banner';
import { GroupAdminBanner } from '../groupAdmin';
import { IState } from '../store/state';
import EvaluationSideBar from './EvaluationSideBar';
import * as Selectors from './selectors';
import { EvaluationActions } from './slice';
import useUserIdFromRoute from './useUserIdFromRoute';

export const AchievementsRoute = '/achievements';

export interface IAchievementsProps {
  appLoaded: boolean;
  onOpen: () => void;
}

export const AchievementsPageFC: React.FC<IAchievementsProps> = ({ appLoaded, onOpen }) => {
  const { t } = useTranslation();
  const userId = useUserIdFromRoute();
  React.useEffect(() => {
    if (appLoaded) {
      onOpen();
    }
  }, [appLoaded, onOpen]);

  const skeletonClass = !appLoaded ? SKELETON_CLASSNAME : '';
  const achievementsLottie = 'Lab_Animation360';
  const title = t('Achievements.Title');
  const contentHtml = t('Achievements.ContentHtml');
  const sidebar = <EvaluationSideBar />;

  return (
    <>
      <Day0Banner />
      <HeroSection lottie={achievementsLottie} className="achievements-section">
        <SectionTitle className={skeletonClass}>{title}</SectionTitle>
        <SectionSubtitle wrapperTag="div" className={skeletonClass}>
          {renderStringToReact(contentHtml, ETagType.div)}
        </SectionSubtitle>
      </HeroSection>
      <GroupAdminBanner userId={userId} />
      <SideBarSection sidebar={sidebar}>
        <div className="col-1"></div>
        <div className="col-8">
          <GlobalAchievementsList />
        </div>
      </SideBarSection>
    </>
  );
};

const mapStateToProps = (state: IState) => {
  const ready = Selectors.isFeatureReady(state);
  const cyclesLoaded = !CyclesSelectors.isCyclesLoading(state);
  const langLoaded = !LanguageSelectors.isLoading(state);
  return {
    appLoaded: ready && cyclesLoaded && langLoaded,
  };
};

const mapDispatchToProps = {
  onOpen: EvaluationActions.openEvaluation,
};

const Achievements = connect(mapStateToProps, mapDispatchToProps)(AchievementsPageFC);
export default Achievements;
